import MilestonesProgressionChart from "../../components/charts/milestoneChart"
import MilestoneTable from "../ui/MilestoneTable"


const MilestonesTable = ({ milestones }) => {
  return (
    <div className="mt-8">
      <h3 className="text-xl font-medium mb-4">Milestones</h3>
      <div className="bg-tableau-bg rounded-xl overflow-hidden shadow-sm border border-tableau-border">
        <table className="w-full border-collapse">
          <thead className="bg-tableau-bg border-b border-tableau-border">
            <tr className="text-left">
              <th className="py-3 px-4 font-medium text-gray-700 w-22 text-center">Milestone #</th>
              <th className="py-3 px-4 font-medium text-gray-700">Milestone name</th>
              <th className="py-3 px-4 font-medium text-gray-700">Milestone description</th>
            </tr>
          </thead>
          <tbody className="text-gray-500 font-normal">
            {milestones.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center py-6 bg-tableau-bg1">
                  No milestones have been recorded yet.
                </td>
              </tr>
            ) : (
              milestones.map((milestone, index) => (
                <tr key={index} className={index % 2 === 0 ? "bg-tableau-bg1" : "bg-tableau-bg"}>
                  <td className="py-3 px-4 text-center">{index + 1}</td>
                  <td className="py-3 px-4">{milestone.title || "[Milestone name]"}</td>
                  <td className="py-3 px-4">
                    {milestone.short_description || "[Milestone description Milestone description]"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}


const formatDate = (dateString) => {
  if (!dateString) return "N/A"
  const date = new Date(dateString)
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date)
}

export default function StudyManagementSection({ study }) {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-xl font-medium mb-4 mt-4">Study management</h3>
          <div className="bg-tableau-bg p-4 rounded-2xl">
            <div className="space-y-6">
              <div>
                <p className="text-base">Created by : {study.createdBy}</p>
              </div>
              <div>
                <p className="text-base">Creation date : {formatDate(study.createdAt) }</p>
              </div>
              <div>
                <p className="text-base">
                  Last modified : {formatDate(study.updatedAt || study.createdAt) }
                </p>
              </div>
              <div>
                <p className="text-base">
                  Last traceability : {formatDate(study.lastTraceability || study.createdAt) }
                </p>
              </div>
              <div>
                <p className="text-base">Master ICF version : {study.masterICF?.[0]?.name }</p>
              </div>
              <div>
                <p className="text-base">Site ICF version date : {formatDate(study.siteICFDate)}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Graphique de progression */}
        <div>
          <MilestonesProgressionChart
            milestoneData={study.milestoneData}
          />
        </div>
      </div>

      {/* Table des jalons */}
      <MilestonesTable
        milestones={
          study.milestones ||
          Array(6).fill({ name: "[Milestone name]", description: "[Milestone description Milestone description]" })
        }
      />
    </div>
  )
}
